
import React from 'react';

import {Helmet} from 'views/module';

import CaregiverScheduleDashboard from 'views/scenes/schedule/caregiver/CaregiverScheduleDashboard';

const CaregiverScheduleDashboardPage = (props) => {
  return (
    <>
      <Helmet>
        <title>Quilt: Caregiver Schedule</title>
      </Helmet>
      <CaregiverScheduleDashboard
      />
    </>
  );
};

export default CaregiverScheduleDashboardPage;
